module.exports = __webpack_public_path__ + "img/fun2.f76d1c76.png";